"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProductFeeExVatForGmBasket = exports.calculateGmThermalBoxFee = exports.calculateGmBasketDeliveryFeeFromSubtotal = exports.calculateGmBasketDeliveryFee = exports.getDeliveryFeeConstantsFromCountry = void 0;
const price_1 = require("./price");
/**
 * Provides default delivery fee values based on the inputted country code
 * @param country 2-letter country code (e.g. "GB", "AU")
 * @param exVat boolean indicating if the values should be ex-VAT
 * @returns delivery fee default values for country. Defaults to UK settings if not defined for specific country
 */
const getDeliveryFeeConstantsFromCountry = (country, exVat = false, tenantId = 'default') => {
    var _a;
    const feeData = {
        default: {
            exVat: {
                default: { deliveryThreshold: 25000, aboveThresholdFee: 2000, belowThresholdFee: 1250 },
                AU: { deliveryThreshold: null, aboveThresholdFee: 1364, belowThresholdFee: 1364 },
            },
            incVat: {
                default: { deliveryThreshold: 30000, aboveThresholdFee: 2400, belowThresholdFee: 1500 },
                AU: { deliveryThreshold: null, aboveThresholdFee: 1500, belowThresholdFee: 1500 },
            },
        },
        '670fa10d073d99a16586e7ce': {
            exVat: {
                default: { deliveryThreshold: 0, aboveThresholdFee: 0, belowThresholdFee: 0 },
            },
            incVat: {
                default: { deliveryThreshold: 0, aboveThresholdFee: 0, belowThresholdFee: 0 },
            },
        },
        '66ab5c5872a12355ff1f968a': {
            exVat: {
                default: { deliveryThreshold: 25000, aboveThresholdFee: 1667, belowThresholdFee: 1250 },
            },
            incVat: {
                default: { deliveryThreshold: 30000, aboveThresholdFee: 2000, belowThresholdFee: 1500 },
            },
        }
    };
    const vatType = exVat ? 'exVat' : 'incVat';
    const entryPoint = (_a = feeData[tenantId]) !== null && _a !== void 0 ? _a : feeData.default;
    const countryFee = country ? entryPoint[vatType][country === null || country === void 0 ? void 0 : country.toUpperCase()] : null;
    return countryFee !== null && countryFee !== void 0 ? countryFee : entryPoint[vatType].default;
};
exports.getDeliveryFeeConstantsFromCountry = getDeliveryFeeConstantsFromCountry;
const calculateGmBasketDeliveryFee = (basket, regionDeliveryFee, countryCode, exVat = false) => {
    if (typeof basket.logistics.customDeliveryFee === 'number')
        return basket.logistics.customDeliveryFee;
    const { subtotal } = (0, price_1.calculateBasketItemsSubtotal)(basket.items);
    const { deliveryThreshold, belowThresholdFee, aboveThresholdFee } = (0, exports.getDeliveryFeeConstantsFromCountry)(countryCode, exVat, basket.settings.tenantId);
    return deliveryThreshold && subtotal >= deliveryThreshold ? aboveThresholdFee : regionDeliveryFee !== null && regionDeliveryFee !== void 0 ? regionDeliveryFee : belowThresholdFee;
};
exports.calculateGmBasketDeliveryFee = calculateGmBasketDeliveryFee;
const calculateGmBasketDeliveryFeeFromSubtotal = (subtotal, customDeliveryFee, regionDeliveryFee, countryCode, exVat = false, tenantId) => {
    if (typeof customDeliveryFee === 'number')
        return customDeliveryFee;
    const { deliveryThreshold, belowThresholdFee, aboveThresholdFee } = (0, exports.getDeliveryFeeConstantsFromCountry)(countryCode, exVat, tenantId);
    return deliveryThreshold && subtotal >= deliveryThreshold ? aboveThresholdFee : regionDeliveryFee !== null && regionDeliveryFee !== void 0 ? regionDeliveryFee : belowThresholdFee;
};
exports.calculateGmBasketDeliveryFeeFromSubtotal = calculateGmBasketDeliveryFeeFromSubtotal;
const calculateGmThermalBoxFee = () => {
    return 3500;
};
exports.calculateGmThermalBoxFee = calculateGmThermalBoxFee;
const calculateProductFeeExVatForGmBasket = (basketSubtotal, productFeePercentage) => {
    return Math.ceil(basketSubtotal * (productFeePercentage / 100));
};
exports.calculateProductFeeExVatForGmBasket = calculateProductFeeExVatForGmBasket;
